import { Button, Grid, Typography } from '@mui/material';
import React, { FC } from 'react';
import { CopyToClipboardButton } from 'src/components/CopyToClipboardButton';
import { FormTextInput } from 'src/components/FormPart/FormTextInput';
import { FormToggleButtonGroup } from 'src/components/FormPart/FormToggleButtonGroup';
import { FormComponentProps } from 'src/components/FormPart/types';
import { GroupFormData } from '../../types';

type GroupFormProps = {
  onAddContacts?: () => void;
  onEditRules?: () => void;
  allowDynamicType?: boolean;
};

export const GroupForm: FC<FormComponentProps<GroupFormData, GroupFormProps>> = props => {
  const { form, onAddContacts, onEditRules, allowDynamicType = true } = props;

  const { id: groupId, type: groupType } = form.watch();

  return (
    <Grid container spacing={1} justifyContent="flex-end">
      <Grid item xs={12}>
        <FormTextInput
          form={form}
          fieldName="name"
          label="Group Name"
          placeholder="Enter Name"
          validation={{
            required: 'Name is required',
          }}
          margin="dense"
        />
      </Grid>

      {!!groupId && (
        <Grid item xs={12}>
          <FormTextInput
            form={form}
            fieldName="id"
            label="Group ID"
            disabled
            endIcon={<CopyToClipboardButton text={groupId} variant="icon" />}
            margin="dense"
          />
        </Grid>
      )}

      <Grid item xs={12}>
        <FormTextInput
          form={form}
          fieldName="description"
          label="Description"
          placeholder="Enter Description"
          multiline
          rows={4}
          margin="dense"
        />
      </Grid>

      {allowDynamicType && (
        <Grid item xs={12}>
          <FormToggleButtonGroup
            form={form}
            fieldName="type"
            options={[
              { title: 'Standard', value: 'custom' },
              { title: 'Dynamic', value: 'dynamic' },
            ]}
            disabled={!!groupId}
            disableUnselect
            validation={{
              required: 'Type is required',
            }}
            size="small"
            margin="dense"
          />
        </Grid>
      )}

      {!!groupId && (
        <Grid item xs={12}>
          <Typography variant="caption" fontStyle="italic">
            NOTE: All campaigns associated with this group will be updated to use the newly specified group name.
          </Typography>
        </Grid>
      )}

      <Grid item xs={12}>
        <Grid container spacing={1} justifyContent="space-between">
          <Grid item>
            <Grid container spacing={1}>
              {groupId && groupType === 'custom' && onAddContacts && (
                <Grid item>
                  <Button onClick={onAddContacts} variant="outlined" color="primary">
                    Add Contacts
                  </Button>
                </Grid>
              )}

              {groupId && groupType === 'dynamic' && onEditRules && (
                <Grid item>
                  <Button onClick={onEditRules} variant="outlined" color="primary">
                    Edit Rules
                  </Button>
                </Grid>
              )}
            </Grid>
          </Grid>

          {/* Submit button */}
          <Grid item>
            <Button
              type="submit"
              disabled={form.formState.isSubmitting}
              variant="contained"
              color="secondary"
            >
              {groupId ? 'Update' : 'Create'}
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};
